
import { Button } from "@/components/ui/button";
import { Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import React, { useState } from "react";

interface CopyButtonProps {
  text: string;
  className?: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({ text, className = "" }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);

      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <Tooltip title={isCopied ? "Copied!" : "Copy to clipboard"}>
      <Button
        sx={{
          textTransform: "capitalize",
          fontSize: "0.25rem",
        }}
        variant={"outline"}
        onClick={handleCopy}
        startIcon={<ContentCopyIcon />}
        className={`text-xs p-2 ml-2`}
      >
        Copy
      </Button>
    </Tooltip>
  );
};

export default CopyButton;

